import { MenuIcon } from './MenuIcon';

/**
 * author: Google
 * id 0BD2CD08-CCFB-4EC3-B96D-08B0B8230A91
 * name menu
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu.svg
 * tags
 */
export const HamburgerMenuIcon = MenuIcon;
export default HamburgerMenuIcon